import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import Beatloader from '../../../../../Common/BeatLoader';
import { getTutorCompletedAssStudentListData } from '../../../../../Redux/action/TutorAction';
import ResponsivePagination from '../../../../../Common/Pagination';

const host = process.env.REACT_APP_API_SERVER
const TutorCompletedAssList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { b64id } = useParams();

    useEffect(() => {
        try {

            let assessment_id = atob(b64id);

            if (!assessment_id || isNaN(assessment_id)) {
                throw new Error("Invalid course ID");
            }

            dispatch(getTutorCompletedAssStudentListData(assessment_id))
        } catch (error) {

            // navigate(-1);
        }
    }, [b64id]);



    const {
        loadingTutorCompletedAssStudentListApi,
        TutorCompletedAssStudentListApiData,
        TutorCompletedAssStudentListApiError

    } = useSelector(state => state?.TutorReducer);

    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorCompletedAssStudentListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorCompletedAssStudentListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorCompletedAssStudentListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorCompletedAssStudentListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };



    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Completed Assessment Student List
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorCompletedAssStudentListApi ?
                                    <Beatloader />
                                    :
                                    <div className="row">
                                        {TutorCompletedAssStudentListApiData?.length ?
                                            currentData?.map((data) => (
                                                <div className="col-lg-6 mb-3">
                                                    <Link to={`/tutor/${data?.question_type ? 'tutor-subjective-test' : 'tutor-objective-test'}`} state={{ assessment_id: data?.id, student_id: data?.student_data?.[0]?.id }} className="text-decoration-none">
                                                        <div className="card input-card-form">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-4">
                                                                        <img
                                                                            src={`${host}/${data?.student_data?.[0]?.profile_img}`}
                                                                            className="img-fluid"
                                                                            style={{ height: "7.6rem", width: "auto" }}
                                                                            onError={(e) => {
                                                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-8">
                                                                        <h5 className="mb-0 text-dark">{data?.student_data?.[0]?.name}</h5>
                                                                        <p className="mb-0 text-primary">Assessment Name : {data?.assesment_name}</p>
                                                                        <p className="mb-0 text-primary">Course Name : {data?.course?.name}</p>
                                                                        <div className="row mt-2">
                                                                            <div className="col-lg-6">
                                                                                <h6 className="mb-0 text-dark">Assign Date</h6>
                                                                                <p className="mb-0 text-primary">{data?.assesment_date}</p>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                                <h6 className="mb-0 text-end text-dark">Submit Date</h6>
                                                                                <p className="mb-0 text-end text-primary">{data?.assesment_submit_date}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>}

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}
                                    </div>
                                }
                            </main>


                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorCompletedAssList